<r1-kpi-card
    [title]="card.title"
    [value]="card.count"
    [label]="card.about"
    [options]="card.title === 'MRR' ? mrrOptions : options"
    (optionChange)="toggleOption($event)" />
